import axios from 'axios';
import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from "./router";

import './assets/styles/tailwind.scss';

import useUser from './composables/user';
import { useAuthStore } from '@/stores/auth';

const {getToken, clearToken} = useUser();

// axios.defaults.baseURL = "http://localhost:8080";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();

axios.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;

        if (response && (response.status === 401 || response.status === 403)) {
            const auth = useAuthStore();

            clearToken();
            auth.removeLoggedIn();
            window.location.href = '/login';
            console.log('location href');
        }

        return Promise.reject(error);
    }
);

const pinia = createPinia()
const app = createApp(App);
app.use(pinia);
app.use(router);
app.mount('#app');
